
const galleryUrl = 'https://gallery.cadgl.com'

export default galleryUrl;